import { IIconProps, Icon } from 'native-base'
import React from 'react'
import { Circle, Path, Rect } from 'react-native-svg'

interface Props extends Omit<IIconProps, 'color'> {
  color?: string
}

const CarIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M1.31982 10.9408L1.21275 10.1985C0.84372 10.2518 0.569824 10.568 0.569824 10.9408H1.31982ZM6.02626 10.262V9.512C5.99043 9.512 5.95465 9.51457 5.91919 9.51968L6.02626 10.262ZM22.6801 10.262H23.4301C23.4301 9.84779 23.0943 9.512 22.6801 9.512V10.262ZM22.6801 15.3306V16.0806C23.0943 16.0806 23.4301 15.7448 23.4301 15.3306H22.6801ZM1.31982 15.3306H0.569824C0.569824 15.7448 0.905611 16.0806 1.31982 16.0806L1.31982 15.3306ZM3.13984 16.0806C3.55405 16.0806 3.88984 15.7448 3.88984 15.3306C3.88984 14.9164 3.55405 14.5806 3.13984 14.5806V16.0806ZM7.80005 14.5806C7.38583 14.5806 7.05005 14.9164 7.05005 15.3306C7.05005 15.7448 7.38583 16.0806 7.80005 16.0806V14.5806ZM20.8098 14.5806C20.3956 14.5806 20.0598 14.9164 20.0598 15.3306C20.0598 15.7448 20.3956 16.0806 20.8098 16.0806V14.5806ZM16.1496 16.0806C16.5638 16.0806 16.8996 15.7448 16.8996 15.3306C16.8996 14.9164 16.5638 14.5806 16.1496 14.5806V16.0806ZM5.31564 9.78045C5.04969 10.098 5.09153 10.571 5.40909 10.837C5.72665 11.1029 6.19967 11.0611 6.46562 10.7435L5.31564 9.78045ZM8.92267 6.6416V5.8916C8.70073 5.8916 8.49018 5.9899 8.34768 6.16006L8.92267 6.6416ZM17.2042 6.6416L17.8259 6.222C17.6864 6.01542 17.4535 5.8916 17.2042 5.8916V6.6416ZM19.0264 10.6816C19.2581 11.0249 19.7243 11.1154 20.0676 10.8836C20.4109 10.6519 20.5014 10.1857 20.2697 9.84239L19.0264 10.6816ZM1.42689 11.6832L6.13333 11.0043L5.91919 9.51968L1.21275 10.1985L1.42689 11.6832ZM6.02626 11.012H22.6801V9.512H6.02626V11.012ZM21.9301 10.262V15.3306H23.4301V10.262H21.9301ZM2.06982 15.3306V10.9408H0.569824V15.3306H2.06982ZM3.13984 14.5806H1.31982V16.0806H3.13984V14.5806ZM22.6801 14.5806H20.8098V16.0806H22.6801V14.5806ZM6.46562 10.7435L9.49766 7.12315L8.34768 6.16006L5.31564 9.78045L6.46562 10.7435ZM8.92267 7.3916H17.2042V5.8916H8.92267V7.3916ZM16.5826 7.06121L19.0264 10.6816L20.2697 9.84239L17.8259 6.222L16.5826 7.06121ZM7.11671 15.0056C7.11671 15.8911 6.39888 16.6089 5.51338 16.6089V18.1089C7.2273 18.1089 8.61671 16.7195 8.61671 15.0056H7.11671ZM5.51338 16.6089C4.62788 16.6089 3.91004 15.8911 3.91004 15.0056H2.41004C2.41004 16.7195 3.79945 18.1089 5.51338 18.1089V16.6089ZM3.91004 15.0056C3.91004 14.1201 4.62788 13.4023 5.51338 13.4023V11.9023C3.79945 11.9023 2.41004 13.2917 2.41004 15.0056H3.91004ZM5.51338 13.4023C6.39888 13.4023 7.11671 14.1201 7.11671 15.0056H8.61671C8.61671 13.2917 7.2273 11.9023 5.51338 11.9023V13.4023ZM20.0947 15.0056C20.0947 15.8911 19.3768 16.6089 18.4913 16.6089V18.1089C20.2053 18.1089 21.5947 16.7195 21.5947 15.0056H20.0947ZM18.4913 16.6089C17.6058 16.6089 16.888 15.8911 16.888 15.0056H15.388C15.388 16.7195 16.7774 18.1089 18.4913 18.1089V16.6089ZM16.888 15.0056C16.888 14.1201 17.6058 13.4023 18.4913 13.4023V11.9023C16.7774 11.9023 15.388 13.2917 15.388 15.0056H16.888ZM18.4913 13.4023C19.3768 13.4023 20.0947 14.1201 20.0947 15.0056H21.5947C21.5947 13.2917 20.2053 11.9023 18.4913 11.9023V13.4023ZM16.1496 14.5806H7.80005V16.0806H16.1496V14.5806Z"
        fill={color}
      />
    </Icon>
  )
}

const RelaxIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M19.2677 9.09464C15.5913 8.14063 12.8786 11.1985 12.0254 12.8467C11.0656 10.7816 8.5061 8.5711 4.57955 9.09464C4.40504 12.3231 5.21943 17.0059 12.0254 17.0059C18.8314 17.0059 19.5004 11.4215 19.2677 9.09464Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <Path
        d="M12.1123 5.98242C14.1774 7.45609 17.0569 12.7593 12.1123 16.8313C6.93506 13.0502 9.75636 7.29127 12.1123 5.98242Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <Path
        d="M4.84154 12.4971C3.82354 12.8267 1.6654 13.8117 1.17676 15.1148C3.64903 17.9651 5.9177 19.0995 9.98968 16.9181"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M19.0637 12.4971C20.0817 12.8267 22.2399 13.8117 22.7285 15.1148C20.2562 17.9651 17.9876 19.0995 13.9156 16.9181"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const PowerIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M12 10V2.5L6.5 14H12V21.5L17.4998 10H13.9998"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const ConcentrateIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle cx="12" cy="12" r="7" stroke={color} strokeWidth="1.5" />
      <Circle cx="12" cy="12" r="2" stroke={color} strokeWidth="1.5" />
      <Path
        d="M12 5V3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M19 12L21 12"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12 21L12 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M3 12H5"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  )
}

const BookOpenIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M22 3H16C14.9391 3 13.9217 3.42143 13.1716 4.17157C12.4214 4.92172 12 5.93913 12 7V21C12 20.2044 12.3161 19.4413 12.8787 18.8787C13.4413 18.3161 14.2044 18 15 18H22V3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 3H8C9.06087 3 10.0783 3.42143 10.8284 4.17157C11.5786 4.92172 12 5.93913 12 7V21C12 20.2044 11.6839 19.4413 11.1213 18.8787C10.5587 18.3161 9.79565 18 9 18H2V3Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const CoffeeIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M18 8H19C20.0609 8 21.0783 8.42143 21.8284 9.17157C22.5786 9.92172 23 10.9391 23 12C23 13.0609 22.5786 14.0783 21.8284 14.8284C21.0783 15.5786 20.0609 16 19 16H18"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M2 8H18V17C18 18.0609 17.5786 19.0783 16.8284 19.8284C16.0783 20.5786 15.0609 21 14 21H6C4.93913 21 3.92172 20.5786 3.17157 19.8284C2.42143 19.0783 2 18.0609 2 17V8Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M14 1V4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M10 1V4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M6 1V4"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const BriefCaseIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M16 21V5C16 4.46957 15.7893 3.96086 15.4142 3.58579C15.0391 3.21071 14.5304 3 14 3H10C9.46957 3 8.96086 3.21071 8.58579 3.58579C8.21071 3.96086 8 4.46957 8 5V21"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const HappyIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15.8618 15.4971C15.8618 15.4971 14.886 16.6117 14.0001 17.0416C13.2937 17.3843 12.7982 17.5963 12.0167 17.5963C11.2352 17.5963 10.724 17.3793 10.0001 17.0416C9.07879 16.6118 8.0293 15.4971 8.0293 15.4971"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M9.5 10C9.74028 10 9.86042 10 9.93306 9.87755C10.0057 9.7551 9.96299 9.67692 9.87758 9.52057C9.8323 9.43767 9.7751 9.36089 9.70711 9.29289C9.51957 9.10536 9.26522 9 9 9C8.73478 9 8.48043 9.10536 8.29289 9.29289C8.2249 9.36089 8.16771 9.43767 8.12242 9.52056C8.03701 9.67692 7.9943 9.7551 8.06694 9.87755C8.13958 10 8.25972 10 8.5 10L9 10H9.5Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M15.5 10C15.7403 10 15.8604 10 15.9331 9.87755C16.0057 9.7551 15.963 9.67692 15.8776 9.52057C15.8323 9.43767 15.7751 9.36089 15.7071 9.29289C15.5196 9.10536 15.2652 9 15 9C14.7348 9 14.4804 9.10536 14.2929 9.29289C14.2249 9.36089 14.1677 9.43767 14.1224 9.52056C14.037 9.67692 13.9943 9.7551 14.0669 9.87755C14.1396 10 14.2597 10 14.5 10L15 10H15.5Z"
        fill={color}
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </Icon>
  )
}

const SadIcon = ({ color = '#FFFFFF', strokeWidth, ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
      />
      <Path
        d="M15.4641 17.25C15.113 17.174 14.6081 17.1109 14 17.067C13.3919 17.0231 12.7021 17 12 17C11.2979 17 10.6081 17.0231 10 17.067C9.39192 17.1109 8.88697 17.174 8.5359 17.25"
        stroke={color}
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
      />
      <Path
        d="M9.5 10C9.74028 10 9.86042 10 9.93306 10.1225C10.0057 10.2449 9.96299 10.3231 9.87758 10.4794C9.8323 10.5623 9.7751 10.6391 9.70711 10.7071C9.51957 10.8946 9.26522 11 9 11C8.73478 11 8.48043 10.8946 8.29289 10.7071C8.2249 10.6391 8.16771 10.5623 8.12242 10.4794C8.03701 10.3231 7.9943 10.2449 8.06694 10.1225C8.13958 10 8.25972 10 8.5 10L9 10H9.5Z"
        fill={color}
        stroke={color}
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
      />
      <Path
        d="M15.5 10C15.7403 10 15.8604 10 15.9331 10.1225C16.0057 10.2449 15.963 10.3231 15.8776 10.4794C15.8323 10.5623 15.7751 10.6391 15.7071 10.7071C15.5196 10.8946 15.2652 11 15 11C14.7348 11 14.4804 10.8946 14.2929 10.7071C14.2249 10.6391 14.1677 10.5623 14.1224 10.4794C14.037 10.3231 13.9943 10.2449 14.0669 10.1225C14.1396 10 14.2597 10 14.5 10L15 10H15.5Z"
        fill={color}
        stroke={color}
        strokeWidth={strokeWidth || '1.5'}
        strokeLinecap="round"
      />
    </Icon>
  )
}

const FireIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M10.75 22.5L10.2053 20.757C9.7576 19.3243 9.95773 17.7676 10.7532 16.4948C11.3291 15.5735 12.6709 15.5735 13.2468 16.4948C14.0423 17.7676 14.2424 19.3243 13.7947 20.757L13.25 22.5M19.5 14.7392C19.5 13.3943 18.7616 10.9067 17.7481 8.12597C17.3292 6.97641 15.75 7.30206 15.75 8.53065C15.75 9.81651 14.7426 10.8589 13.5 10.8589C12.2574 10.8589 11.25 9.81651 11.25 8.53065C11.25 4.25066 11.25 2.11066 10.4439 1.67541C10.186 1.53614 9.8706 1.47534 9.58151 1.50916C8.67804 1.61484 7.94614 3.57693 6.48234 7.5011C5.35233 10.5304 4.5 13.2943 4.5 14.7392C4.5 19.0254 7.85786 22.5 12 22.5C16.1421 22.5 19.5 19.0254 19.5 14.7392Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  )
}

const DrinkLightIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M9 21H15"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <Path
        d="M12 21V17"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M5 9.28571C5 9.02012 5 8.88733 5.02507 8.77748C5.11055 8.40298 5.40298 8.11055 5.77748 8.02507C5.88733 8 6.02012 8 6.28571 8H17.7143C17.9799 8 18.1127 8 18.2225 8.02507C18.597 8.11055 18.8895 8.40298 18.9749 8.77748C19 8.88733 19 9.02012 19 9.28571V10C19 10.9288 19 11.3933 18.9487 11.7832C18.5942 14.4756 16.4756 16.5942 13.7832 16.9487C13.3933 17 12.9288 17 12 17V17C11.0712 17 10.6067 17 10.2168 16.9487C7.52444 16.5942 5.40579 14.4756 5.05133 11.7832C5 11.3933 5 10.9288 5 10V9.28571Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <Path
        d="M12 12L13.7305 5.9432C13.8628 5.48006 13.929 5.24849 14.0845 5.07626C14.24 4.90402 14.4636 4.81457 14.9108 4.63569L19 3"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}

const WorkoutIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Rect
        x="4.09131"
        y="6.94629"
        width="3.2904"
        height="10.1089"
        rx="1.6452"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M1.55859 10.6435C1.55859 9.24448 2.69272 8.11035 4.09173 8.11035V8.11035V15.8928V15.8928C2.69272 15.8928 1.55859 14.7586 1.55859 13.3596V10.6435Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M22.4551 10.6435C22.4551 9.24448 21.321 8.11035 19.9219 8.11035V8.11035V15.8928V15.8928C21.321 15.8928 22.4551 14.7586 22.4551 13.3596V10.6435Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <Rect
        x="16.6318"
        y="6.72852"
        width="3.29058"
        height="10.5455"
        rx="1.64529"
        stroke={color}
        strokeWidth="1.5"
      />
      <Path
        d="M7.40283 9.86719H16.6292V14.0919H7.40283"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  )
}

const AcousticGuitarIcon = ({ color = '#FFFFFF', ...props }: Props) => {
  return (
    <Icon viewBox="0 0 24 24" {...props} color="transparent">
      <Path
        d="M18.1323 11.2389C18.636 10.4237 18.856 9.52207 18.7708 8.622C18.6856 7.72193 18.2981 6.85423 17.6462 6.10366C16.9942 5.3531 16.1002 4.74533 15.0513 4.33973C14.0024 3.93413 12.8346 3.74457 11.6619 3.78955C10.4892 3.83454 9.35169 4.11255 8.36057 4.59641C7.36944 5.08027 6.55855 5.75345 6.0071 6.55018C5.45565 7.34691 5.1825 8.23995 5.21434 9.14207C5.24617 10.0442 5.5819 10.9245 6.18873 11.6971M18.516 15.0672C19.3553 15.8491 19.8802 16.964 19.8802 18.2015C19.8802 20.5667 17.9628 22.484 15.5977 22.484H8.40265C6.03747 22.484 4.12012 20.5667 4.12012 18.2015C4.12012 16.8132 4.78074 15.5792 5.80478 14.7966M18.1605 11.1926C17.3707 12.2802 17.1726 13.7232 18.5503 15.101M6.00437 11.4434C6.88756 12.4967 6.57747 14.2823 5.63207 14.9426M11.116 7.64169H12.9732C13.5803 7.64169 14.0473 7.10508 13.9636 6.50375L13.3378 2.0105C13.269 1.51628 12.8464 1.14844 12.3474 1.14844H11.7008C11.1984 1.14844 10.774 1.52119 10.7091 2.01939L10.1244 6.51264C10.0465 7.11112 10.5125 7.64169 11.116 7.64169ZM14.959 12.375C14.959 14.0091 13.6344 15.3338 12.0003 15.3338C10.3663 15.3338 9.04163 14.0091 9.04163 12.375C9.04163 10.741 10.3663 9.41634 12.0003 9.41634C13.6344 9.41634 14.959 10.741 14.959 12.375Z"
        stroke={color}
        strokeWidth="1.5"
      />
    </Icon>
  )
}

export {
  CarIcon,
  RelaxIcon,
  PowerIcon,
  ConcentrateIcon,
  BookOpenIcon,
  CoffeeIcon,
  BriefCaseIcon,
  HappyIcon,
  SadIcon,
  FireIcon,
  DrinkLightIcon,
  WorkoutIcon,
  AcousticGuitarIcon,
}
